/**
 * Writes `text` to the clipboard and only then reports it to `onCopy`. A failed
 * write (denied permission, or a non-secure context where `navigator.clipboard`
 * is absent) leaves nothing on the clipboard, so callers — which use `onCopy` to
 * record that the user took the snippet — must not be told a copy happened.
 */
const copyToClipboard = async (
  text: string,
  onCopy?: (text: string) => void,
): Promise<void> => {
  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    console.warn("Could not write the snippet to the clipboard:", error);
    return;
  }

  onCopy?.(text);
};

export default copyToClipboard;
